import axios from "axios";
import { auth } from "../config/firebase";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5172/api";

const getAuthHeader = async () => {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

const cartService = {
  addToCart: async (productId, quantity = 1, image) => {
    const user = auth.currentUser;
    if (!user) return { notLoggedIn: true };

    const headers = await getAuthHeader();
    return axios.post(
      `${API_URL}/cart/items`,
      { productId, quantity, image },
      { headers },
    );
  },

  /* ===============================
     ONLINE PAYMENT (RAZORPAY)
     =============================== */
  createRazorpayOrder: async ({ shippingFee, shippingAddress, couponCode }) => {
    const headers = await getAuthHeader();

    const res = await axios.post(
      `${API_URL}/payments/create-checkout-session`,
      {
        shippingFee,
        shippingAddress,
        couponCode, // ✅ Correctly passing coupon
      },
      { headers },
    );

    return res.data;
  },

  /* ===============================
     COD PAYMENT
     =============================== */
  placeCODOrder: async ({ shippingFee, shippingAddress, couponCode }) => {
    // ✅ Added couponCode here
    const headers = await getAuthHeader();

    const res = await axios.post(
      `${API_URL}/payments/cod`,
      {
        shippingFee,
        shippingAddress,
        couponCode, // ✅ Added couponCode here
      },
      { headers },
    );

    return res.data;
  },

  /* ===============================
     CART APIs
     =============================== */
  getCart: async () => {
    const headers = await getAuthHeader();
    const res = await axios.get(`${API_URL}/cart`, { headers });
    return res.data;
  },

  updateCartItem: async (cartItemId, quantity) => {
    const headers = await getAuthHeader();
    return axios.put(
      `${API_URL}/cart/items/${cartItemId}`,
      { quantity },
      { headers },
    );
  },

  removeCartItem: async (cartItemId) => {
    const headers = await getAuthHeader();
    return axios.delete(`${API_URL}/cart/items/${cartItemId}`, { headers });
  },

  clearCart: async () => {
    const headers = await getAuthHeader();
    return axios.delete(`${API_URL}/cart/clear`, { headers });
  },

  confirmPayment: async ({ orderId }) => {
    const headers = await getAuthHeader();
    return axios.post(`${API_URL}/payments/confirm`, { orderId }, { headers });
  },
};

export default cartService;
